import { defineMessages } from "react-intl";

import {
	ableTo6mwtMessages,
	validator
} from "lib/build/forms/htx/current-cardiological-state/6Mwt";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	"6mwt": {
		id: "form.6mwt",
		defaultMessage: "6MWT"
	},
	ableTo6mwt: {
		id: "form.6mwt.able_to_6mwt",
		defaultMessage: "Beteg állapota 6MWT járástesztre alkalmas-e?"
	},
	value: {
		id: "form.6mwt.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	ableTo6mwt: {
		type: "field",
		path: ["ableTo6mwt"],
		label: messages.ableTo6mwt,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: ableTo6mwtMessages } }
	},
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.ableTo6mwt }] },
		{ columns: [{ width: 12, field: fields.value }] }
	]
};

export const node: LeafNode = {
	id: "6mwt",
	value: {
		title: messages["6mwt"],
		validator,
		fieldset,
		isImportant: true
	}
};
